import styled from 'styled-components';
const ChangeLevelStyled = styled.div`
  background-color: #fff;
  border-radius: 12px;
  min-height: 500px;
  padding: 32px;
  .member-level {
    width: 100%;
  }
  .reason {
    > div {
      width: 100%;
    }
  }
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    /* .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    } */
  }
`;
export default ChangeLevelStyled;
